import {postMethod} from '~/api'

async function post(id) {
    return await postMethod(`/api/companyRegistration/${id}/activate`)
}

export {post}
